import Vue from 'vue'
import App from './App.vue'
import 'amfe-flexible/index.js'
import router from '@/router'
import "@/styles/reset.css"
import { Toast, Dialog, Button, Field, Tab, Tabs, Picker, Popup, DatetimePicker } from 'vant';
import 'vant/lib/toast/style';
import 'vant/lib/dialog/style';
import 'vant/lib/button/style';
import 'vant/lib/field/style';
import 'vant/lib/tab/style';
import 'vant/lib/tabs/style';
import 'vant/lib/picker/style';
import 'vant/lib/popup/style';
import 'vant/lib/datetime-picker/style';

Vue.use(Toast);
Vue.use(Dialog);
Vue.use(Button);
Vue.use(Field);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Picker);
Vue.use(Popup);
Vue.use(DatetimePicker);

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
